/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    shape,
    array,
    string,
    arrayOf,
} from 'prop-types';
import { useUIDSeed } from 'react-uid';
import GraphqlBreadcrumbs from '../GraphqlCommonComponents/GraphqlBreadcrumbs/GraphqlBreadcrumbs';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import LinkOrATag from '../GraphqlCommonComponents/LinkOrATag/LinkOrATag';

const useStyles = makeStyles((theme) => ({
    siteContainer: {
        maxWidth: '980px',
        margin: '20px auto',
        padding: '0 15px',
        '& h1': {
            fontSize: '24px',
        },
    },
    headerBar: {
        backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
        color: theme.palette.colorPrimaryContrast || theme.palette.cms?.colorPrimaryContrast,
        padding: '3px 7px',
        fontSize: '14px',
        fontWeight: 'bold',
    },
    ul: {
        padding: 0,
        margin: '5px 0 10px 0',
        display: 'flex',
        flexWrap: 'wrap',
    },
    listItem: {
        listStyle: 'none',
        padding: '7px',
        flex: '0 0 25%',
        maxWidth: '34%',
        lineHeight: '16px',
        '& a': { color: theme.palette.cms?.primary || theme.palette.colorPrimary, fontSize: '13px' },
    },
}));

const HtmlSitemapBuilder = ({ sitemapData }) => {
    const classes = useStyles();
    const heading = sitemapData?.content?.entries?.[0]?.heading;
    const categoryGroupArray = sitemapData?.content?.entries?.[0]?.category_group;
    const cmsColorvariable = sitemapData?.content?.entries?.[0]?.category_heading_background_color;
    const seed = useUIDSeed();
    const seoArray = sitemapData?.content?.entries?.[0]?.seo;
    return (
        <div className={classes.siteContainer}>
            {/* breadcrumb component goes here */}
            {seoArray?.breadcrumb && <GraphqlBreadcrumbs breadCrumbArray={seoArray.breadcrumb} />}
            <GraphqlSeoHeadTags seoData={seoArray} />
            <h1 aria-hidden="true">{heading}</h1>
            {categoryGroupArray.map((data) => (
                <>
                    <div role="region" aria-label={data.heading} key={seed(data)} className={classes.headerBar} style={{ backgroundColor: cmsColorvariable }}>
                        {data.heading}
                    </div>
                    <div role="region" aria-label="listtext" className={classes.ul}>
                        {data.link.map((d) => (
                            <div key={seed(d)} className={classes.listItem}>
                                <LinkOrATag href={d.href}>{d.title}</LinkOrATag>
                            </div>
                        ))}
                    </div>
                </>
            ))}
        </div>
    );
};
HtmlSitemapBuilder.propTypes = {
    sitemapData: shape({
        content: shape({
            entries: arrayOf(shape({
                category_group: array,
                category_heading_background_color: string,
                heading: string,
            })),
        }),
    }).isRequired,
};
export default HtmlSitemapBuilder;
